/* eslint-disable import/prefer-default-export */
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './ModalMessages.scss';

const ModalMessages = React.forwardRef(
  (
    {
      children,
      className,
      ...props
    },
    /* eslint-disable-next-line no-unused-vars */
    ref
  ) => (
    <div className={cx('ModalMessages', className)} {...props}>
      {children}
    </div>
  )
);

ModalMessages.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.element
    ),
  ]),
  className: PropTypes.string,
};

ModalMessages.defaultProps = {
  children: undefined,
  className: undefined,
};

ModalMessages.displayName = 'ModalMessages';
export default ModalMessages;
